export const getTicketProductForm = (
  product?: FilteredProductItem,
): TicketProductForm => {
  if (!product)
    return {
      id: 0,
      type: 'normal',
      description: 'DESCRIÇÃO',
      ean: '1234567891234',
      code: '12345',
    };
  const { id, type, description, ean, code } = product;
  return {
    id,
    type,
    description,
    ean,
    code,
  };
};
